<template>
    <div class="bc__ui__button__circle">
        <a :href="href">
            <arrow-up-right :size="internal_size"></arrow-up-right>
        </a>
    </div>
</template>

<script>
import {ArrowUpRight} from 'lucide-vue-next';

export default {
    props: ['href', 'size'],
    data () {
      return {
          internal_size : 20,
      }
    },
    mounted() {
        if(this.size){
            this.internal_size = this.size
        }
    },

    components: {
        ArrowUpRight,
    },
};
</script>
